var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldServicesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0A1.75 1.75 0 005 1.75V5H1.75A1.75 1.75 0 000 6.75v4c0 .966.784 1.75 1.75 1.75H5v3.25c0 .966.784 1.75 1.75 1.75h4a1.75 1.75 0 001.75-1.75V12.5h3.25a1.75 1.75 0 001.75-1.75v-4A1.75 1.75 0 0015.75 5H12.5V1.75A1.75 1.75 0 0010.75 0h-4z",
    fill: "#333230"
  })));
}
export default SvgPldServicesFilled;